import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const bitcoinSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getBitcoinRate: build.query<any, void>({
      query: () => `${urlConfig.tradesBaseUrl}/trades/rates/bitcoin`,
    }),
    getUsdtRate: build.query<any, void>({
      query: () => `${urlConfig.tradesBaseUrl}/trades/rates/usdt`,
    }),
    getCoinRate: build.query<any, string>({
      query: coin => `${urlConfig.tradesBaseUrl}/trades/rates/${coin}`,
    }),
    getCoinTrend: build.query<any, string>({
      query: coin => `${urlConfig.tradesBaseUrl}/trades/rates/${coin}/trend`,
    }),
  }),
})

export const {
  useGetBitcoinRateQuery,
  useGetUsdtRateQuery,
  useGetCoinRateQuery,
  useGetCoinTrendQuery,
} = bitcoinSlice
